import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import map from 'lodash/map';
import reject from 'lodash/reject';
import useModelRegistryUpdateItemMutation from '@API/model-registry/useModelRegistryUpdateItemMutation';
import Tag from '@/shared/components/TableCells/Tag';
import RemainingTags from '@shared/components/TableCells/ResizableExperimentTagList/RemainingTags';
import useShowRemainingContent from '@/helpers/custom-hooks/useShowRemainingContent';
import alertsUtil from '@/util/alertsUtil';
import { dialogTypes } from '@/constants/alertTypes';
import { TagsCellProps } from './TagsCell.type';
import classes from './TagsCell.module.scss';

const TagsCell: React.FC<TagsCellProps> = ({ row }) => {
  const { modelName = '', workspace = '' } = useParams<{
    modelName?: string;
    workspace?: string;
  }>();

  const dispatch = useDispatch();

  const updateModelRegistryItemStateMutation = useModelRegistryUpdateItemMutation(
    { workspace, modelName }
  );

  const { containerRef, shouldShowRemainingContent } = useShowRemainingContent(
    map(row.tags, 'tag')
  );

  const handleConfirmDelete = (tagName: string) => {
    updateModelRegistryItemStateMutation.mutate({
      registryModelItemId: row.rowData.registryModelItemId,
      values: {
        comment: '',
        stages: map(reject(row.tags, { stage: tagName }), 'stage')
      }
    });
    dispatch(alertsUtil.closeDialog(dialogTypes.CONFIRM_DELETE_TAG_FROM_MODEL));
  };

  const handleDeleteTag = (tagName: string) => {
    dispatch(
      alertsUtil.openConfirmDialog(
        dialogTypes.CONFIRM_DELETE_TAG_FROM_MODEL,
        'This will remove the tag from your model',
        () => handleConfirmDelete(tagName),
        'Delete'
      )
    );
  };

  const renderTags = () => {
    return row.tags.map(tag => (
      <Tag
        key={tag.tag}
        tagColor={tag.color}
        tagName={tag.tag}
        onDeleteTag={handleDeleteTag}
      />
    ));
  };

  return (
    <div className={classes.root} ref={containerRef}>
      <div className={classes.tagsWrapper}>
        <div className={classes.tags}>{renderTags()}</div>
      </div>
      {shouldShowRemainingContent && (
        <RemainingTags>{renderTags()}</RemainingTags>
      )}
    </div>
  );
};

export default TagsCell;
